import { agentsApi } from '../../../data/agentsApi';
import type { StepView } from './stepRecipeViews';

/**
 * stepRecipe feature endpoints, injected into the single agents base api.
 * Per-step read query + mutations for enabled toggle and parameter updates.
 */
export const stepRecipeEndpoints = agentsApi.injectEndpoints({
  endpoints: (builder) => ({
    getSteps: builder.query<StepView[], { agentKey: string; company?: string }>({
      query: ({ agentKey, company }) => ({
        url: `/agents/${agentKey}/steps`,
        method: 'GET',
        params: company ? { company } : undefined,
      }),
      providesTags: (_result, _error, { agentKey }) => [{ type: 'StepRecipe', id: agentKey }],
    }),
    setStepEnabled: builder.mutation<
      StepView,
      { agentKey: string; stepKey: string; enabled: boolean; company?: string }
    >({
      query: ({ agentKey, stepKey, enabled, company }) => ({
        url: `/agents/${agentKey}/steps/${stepKey}/enabled`,
        method: 'PUT',
        params: company ? { company } : undefined,
        body: { enabled },
      }),
      invalidatesTags: (_result, _error, { agentKey }) => [{ type: 'StepRecipe', id: agentKey }],
    }),
    setStepParameters: builder.mutation<
      StepView,
      { agentKey: string; stepKey: string; parameters: Record<string, unknown>; company?: string }
    >({
      query: ({ agentKey, stepKey, parameters, company }) => ({
        url: `/agents/${agentKey}/steps/${stepKey}/parameters`,
        method: 'PUT',
        params: company ? { company } : undefined,
        body: { parameters },
      }),
      invalidatesTags: (_result, _error, { agentKey }) => [{ type: 'StepRecipe', id: agentKey }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetStepsQuery, useSetStepEnabledMutation, useSetStepParametersMutation } = stepRecipeEndpoints;
